import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=90234fa4&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=90234fa4&prod&lang=scss"
import style1 from "./Add.vue?vue&type=style&index=1&id=90234fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90234fa4",
  null
  
)

export default component.exports